import * as CmsService from './cmsService'

export default CmsService;